import React from "react";
import { connect } from "react-redux";
import { setEditData, setModalTemplate, setModalType, setShowEditCustomerGroupModal, setShowEditCustomerModal, setShowEditSupplierGroupModal, setShowEditSupplierModal } from '../../redux/modal/modal.actions';
import { createStructuredSelector } from 'reselect';
import { selectEditUUID, selectModalFormTemplate, selectShowEditCustomerGroupModal, selectShowEditSupplierGroupModal, selectShowEditSupplierModal } from "../../redux/modal/modal.reselect";
import { useEffect } from "react";

import EDIT_CUSTOMER_GROUP_FORM_TEMPLATE from './edit-customer-group.template';

import ModalContainer from "../modal/modal.container";
import useFetchEdit from "../../effects/use-fetch-edit.effect";
import { authTokenSelector } from "../../redux/user/user.reselect";

const EditCustomerGroup = ({
    showEditCustomerGroup,
    setModalTemplate,
    setModalType,
    formTemplate,
    editUUID,
    authToken,
    setShowEditCustomerGroupModal,
    isFetching,
    setEditData
}) => {
    useEffect(() => {
        setModalType("EDIT_CUSTOMER_GROUP")
        setModalTemplate(EDIT_CUSTOMER_GROUP_FORM_TEMPLATE);
    }, []);
    const endpoint = '/customergroups';
    const endpointUrl = `${endpoint}/${editUUID}`;
    const authTokenFromState = authToken;

    const { data, error } = useFetchEdit(endpointUrl, authTokenFromState, showEditCustomerGroup);

    useEffect(() => {
        setEditData(data)
    })
    
    return (
        <div className="edit-customer-group">
            {
                Object.keys(formTemplate).length > 0 ?
                    <ModalContainer
                        showModal={showEditCustomerGroup}
                        setShowModal={setShowEditCustomerGroupModal}
                        endpointUrl={endpointUrl}
                        size={"MEDIUM"}
                    />
                    : null
            }
        </div>
    )
}

const mapStateToProps = createStructuredSelector({
    showEditCustomerGroup: selectShowEditCustomerGroupModal,
    formTemplate: selectModalFormTemplate,
    editUUID: selectEditUUID,
    authToken: authTokenSelector,
})

const mapDispatchToProps = (disptach) => ({
    setShowEditCustomerGroupModal: () =>
        disptach(setShowEditCustomerGroupModal()),
    setModalTemplate: (formTemplate) =>
        disptach(setModalTemplate(formTemplate)),
    setModalType: (modalType) =>
        disptach(setModalType(modalType)),
    setEditData: (editData) =>
        disptach(setEditData(editData))
})


export default connect(mapStateToProps, mapDispatchToProps)(EditCustomerGroup);